import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "mainNavButton",
  "use": "mainNavButton-usage",
  "viewBox": "0 0 25 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 25 12\" id=\"mainNavButton\"><use xlink:href=\"#mainNavButton_path0_stroke\" transform=\"translate(0 12)\" fill=\"#9C7446\" fill-opacity=\".7\" /><use xlink:href=\"#mainNavButton_path0_stroke\" transform=\"translate(0 1)\" fill=\"#9C7446\" fill-opacity=\".7\" /><defs><path id=\"mainNavButton_path0_stroke\" d=\"M0 0h25v-1H0v1z\" /></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol